import type { QueryClient } from "@tanstack/react-query";
import { monolithApiClient } from "#/src/configs/axios.config";
import type { ParentReferralAccount } from "./parentReferralOffer";

export function parentReferralAccountQueryKey(userId: string | undefined) {
  return ["my-referral-code", userId] as const;
}

export async function fetchParentReferralAccount(queryClient: QueryClient, userId: string | undefined) {
  const { data } = await monolithApiClient.get<ParentReferralAccount>("/parent/referral-code", {
    silentNetworkError: true,
  });
  const known = queryClient.getQueryData<ParentReferralAccount>(parentReferralAccountQueryKey(userId))?.recipientClaim;
  // A lookup started before completion cannot erase the saved award or its grant marker.
  return { ...data, recipientClaim: known?.recipientGrantedAt ? known : (data.recipientClaim ?? known ?? null) };
}
